import { render, staticRenderFns } from "./PayrollStatusChip.vue?vue&type=template&id=26fbe0d1"
import script from "./PayrollStatusChip.vue?vue&type=script&lang=js"
export * from "./PayrollStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports